import { render } from "./Finish.vue?vue&type=template&id=f3a30ade"
import script from "./Finish.vue?vue&type=script&setup=true&lang=js"
export * from "./Finish.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal/Questionnaire/Finish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3a30ade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3a30ade', __exports__)) {
    api.reload('f3a30ade', __exports__)
  }
  
  module.hot.accept("./Finish.vue?vue&type=template&id=f3a30ade", () => {
    api.rerender('f3a30ade', render)
  })

}


export default __exports__